import { useMisalignments } from "PFApp/booking/parts/hooks";
import {
  BAR_HEIGHT,
  ROW_PADDING,
  VERTICAL_BARS_MARGIN
} from "PFApp/booking/parts/overview/calendar/calendar";
import { CalendarMode, Row } from "PFApp/booking/types";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { useMemo } from "react";

import { useCalendarContext } from "../../../context/calendar_context";
import MisalignmentBar from "./misalignment_bar";

interface IProps {
  row: Row;
  startDate: string;
  withPadding: boolean;
}

const Misalignments = ({ row, startDate, withPadding }: IProps) => {
  const { dayWidth } = useCalendarContext();
  const { utc } = useDateFormatter();
  const { misalignmentBars } = useMisalignments({ row, mode: CalendarMode.Projects });

  const formattedMisalignments = useMemo(
    () =>
      (misalignmentBars || [])
        .map((misalignmentRow, index) =>
          misalignmentRow.map((misalignment) => {
            const daysFromStart = utc(misalignment.start).diff(startDate, "days");
            const endDate = utc(misalignment.end).endOf("day");
            const durationInDays = Math.ceil(endDate.diff(utc(misalignment.start), "days", true));
            return {
              ...misalignment,
              key: `misalignment_${row.key}_${misalignment.start}_${misalignment.end}_${index}`,
              left: daysFromStart * dayWidth,
              width: durationInDays * dayWidth,
              top: index * BAR_HEIGHT + (withPadding ? ROW_PADDING : 0) + VERTICAL_BARS_MARGIN * index
            };
          })
        )
        .flat(),
    [misalignmentBars, startDate, row.key, dayWidth, withPadding]
  );

  return (
    <>
      {formattedMisalignments.map(({ key, left, top, width }) => (
        <MisalignmentBar key={key} left={left} top={top} width={width} />
      ))}
    </>
  );
};

export default Misalignments;
